import { render, staticRenderFns } from "./AuthRecaptcha.vue?vue&type=template&id=15405574&scoped=true&"
import script from "./AuthRecaptcha.vue?vue&type=script&lang=js&"
export * from "./AuthRecaptcha.vue?vue&type=script&lang=js&"
import style0 from "./AuthRecaptcha.vue?vue&type=style&index=0&id=15405574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15405574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
